import React from "react";
import ReactDOM from "react-dom";
import "./assets/stylesheets/app.scss";
import App from "./components/App";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("app")
);
